module.exports = __webpack_public_path__ + "img/pluviometro.7f005ed2.webp";